import { ILocationProvider } from "angular";
import { UrlService } from "angular-ui-router";

export function configureRouting($locationProvider: ILocationProvider,
    $urlServiceProvider: UrlService): void {
    'ngInject';
    $locationProvider.html5Mode(true);
    $urlServiceProvider.config.caseInsensitive(true);
    $urlServiceProvider.config.strictMode(false);
}
